import {
  FETCH_SCREENSAVERS_REQUEST,
  FETCH_SCREENSAVERS_SUCCESS,
  FETCH_SCREENSAVERS_FAILURE,
} from '../actions';

const defaultScreensaversState = {
  screensavers: [],
  loading: false,
  error: false
};

const reducer = (state = defaultScreensaversState, action) => {
  switch(action.type){
    case FETCH_SCREENSAVERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_SCREENSAVERS_SUCCESS:
      return {
        ...state,
        screensavers: action.screensavers,
        loading: false,
      };
    case FETCH_SCREENSAVERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true
      };
    default:
      return state;
  }
}

export default reducer;
